<template>
  <div>
    <el-dialog title="Waterfall Options" :lock-scroll="false" :visible.sync="visible" top="6vh" @close="$emit('close')">
      <div class="ctn">
        <el-divider>App Instance</el-divider>
        <div v-if="utils.runtime.isElectron" class="item">
          <el-checkbox v-model="autoStart"></el-checkbox>
          <div class="item-right" @click="autoStart = !autoStart">开机启动</div>
        </div>
        <div class="item">
          <el-checkbox v-model="closeWindowWithoutConfirm" id="waterfall-option-focus"></el-checkbox>
          <div class="item-right" @click="closeWindowWithoutConfirm = !closeWindowWithoutConfirm">关闭窗口前不询问</div>
        </div>
        <div v-if="utils.runtime.isElectron" class="item">
          <el-checkbox v-model="autoOpenWinOnStart"></el-checkbox>
          <div class="item-right" @click="autoOpenWinOnStart = !autoOpenWinOnStart">启动时自动打开窗口</div>
        </div>

        <el-divider>Terminal</el-divider>
        <div class="item">
          <el-checkbox v-model="termAutoCopySelected"></el-checkbox>
          <div class="item-right" @click="termAutoCopySelected = !termAutoCopySelected">自动复制选中的内容到粘贴板</div>
        </div>
        <div class="item">
          <el-checkbox v-model="termEnableLink"></el-checkbox>
          <div class="item-right" @click="termEnableLink = !termEnableLink">自动识别链接 (设置后在新打开的会话中生效)</div>
        </div>
        <div class="item">
          <el-checkbox v-model="termEnableGPUAccelerate"></el-checkbox>
          <div class="item-right" @click="termEnableGPUAccelerate = !termEnableGPUAccelerate">启用 GPU 加速 (设置后在新打开的会话中生效)</div>
        </div>

        <el-divider>Default Session</el-divider>
        <conf-session-default />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reset" size="mini">重 置</el-button>
        <el-button @click="refresh" size="mini">刷 新</el-button>
        <el-button @click="hide" size="mini">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ConfSessionDefault from './confSessionDefault.vue'

export default {
  name: "conf",
  components: {
    ConfSessionDefault,
  },
  data() {
    return {
      visible: false,

      closeWindowWithoutConfirm: undefined,
      autoStart: undefined,
      autoOpenWinOnStart: undefined,
      globalConf: undefined,

      termAutoCopySelected: undefined,
      termEnableLink: undefined,
      termEnableGPUAccelerate: undefined,
    }
  },
  watch: {
    visible: function() {
      if (this.visible) this.refresh()
    },
    closeWindowWithoutConfirm: function(val, oldVal) {
      console.log("closeWindowWithoutConfirm change val:", val, ", oldVal:", oldVal)
      if (oldVal === undefined) return

      this.globalConf.closeWindowWithoutConfirm = this.closeWindowWithoutConfirm
      this.save()
    },
    termAutoCopySelected: function(val, oldVal) {
      console.log("termAutoCopySelected change val:", val, ", oldVal:", oldVal)
      if (oldVal === undefined) return

      this.globalConf.termAutoCopySelected = this.termAutoCopySelected
      this.save()
    },
    termEnableLink: function(val, oldVal) {
      console.log("termEnableLink change val:", val, ", oldVal:", oldVal)
      if (oldVal === undefined) return

      this.globalConf.termEnableLink = this.termEnableLink
      this.save()
    },
    termEnableGPUAccelerate: function(val, oldVal) {
      console.log("termEnableGPUAccelerate change val:", val, ", oldVal:", oldVal)
      if (oldVal === undefined) return

      this.globalConf.termEnableGPUAccelerate = this.termEnableGPUAccelerate
      this.save()
    },
    autoStart: function(val, oldVal) {
      console.log("autoStart change val:", val, ", oldVal:", oldVal)
      if (oldVal === undefined) return

      this.globalConf.autoStart = this.autoStart
      this.save()
    },
    autoOpenWinOnStart: function(val, oldVal) {
      console.log("autoOpenWinOnStart change val:", val, ", oldVal:", oldVal)
      if (oldVal === undefined) return

      this.globalConf.autoOpenWinOnStart = this.autoOpenWinOnStart
      this.save()
    },
  },
  mounted() {
    let self = this
    this.env.ui.showOptionsAddCallback(() => {
      self.show()
    })

    this.init()
  },
  methods: {
    show() {
      this.visible = true
      this.utils.dom.domFocusById("waterfall-option-focus")
    },
    hide() {
      this.visible = false
    },
    init() {
      let self = this
      this.utils.conf.load((error, conf, response) => {
        if (error && response.statusCode !== 404) {
          self.api.errHandler(error, conf, response)
          return
        }

        if (response.statusCode === 404) {
          self.utils.conf.GlobalConf = self.utils.conf.DefaultConfDefinition
          console.log("There is no user configuration in server, using default:", self.utils.conf.GlobalConf)
        } else {
          self.utils.conf.GlobalConf = conf
          console.log("configuration init load from server GlobalConf:", self.utils.conf.GlobalConf)
        }

        self.utils.conf.takeEffect(self.utils.conf.GlobalConf)

        self.globalConf = self.utils.conf.GlobalConf
        self.closeWindowWithoutConfirm = self.globalConf.closeWindowWithoutConfirm === undefined ? self.utils.conf.DefaultConfDefinition.closeWindowWithoutConfirm : self.globalConf.closeWindowWithoutConfirm
        self.termAutoCopySelected = self.globalConf.termAutoCopySelected === undefined ? self.utils.conf.DefaultConfDefinition.termAutoCopySelected : self.globalConf.termAutoCopySelected
        self.termEnableLink = self.globalConf.termEnableLink === undefined ? self.utils.conf.DefaultConfDefinition.termEnableLink : self.globalConf.termEnableLink
        self.termEnableGPUAccelerate = self.globalConf.termEnableGPUAccelerate === undefined ? self.utils.conf.DefaultConfDefinition.termEnableGPUAccelerate : self.globalConf.termEnableGPUAccelerate
        self.autoStart = self.globalConf.autoStart === undefined ? self.utils.conf.DefaultConfDefinition.autoStart : self.globalConf.autoStart
        self.autoOpenWinOnStart = self.globalConf.autoOpenWinOnStart === undefined ? self.utils.conf.DefaultConfDefinition.autoOpenWinOnStart : self.globalConf.autoOpenWinOnStart
      })
    },
    reset: function() {
      console.log("reset conf")
      this.utils.conf.reset(this.saveErrHandler())
    },
    save() {
      console.log("save conf:", this.globalConf)
      this.utils.conf.save(this.globalConf, this.saveErrHandler())
    },
    saveErrHandler(error, data, response) {
      this.api.errHandler(this, error, response)
    },
    initConfErrHandler(err, data, response) {
      this.api.errHandler(this, err, response)
    },
    resetConfErrHandler(err, data, response) {
      this.api.errHandler(this, err, response)
    },
    refresh() {
      this.init()
    }
  },
}
</script>

<style scoped>
.item {
  display: flex;
  align-items: baseline;
  user-select: none;
  margin-bottom: 16px;
}
.item-right {
  padding-left: 0.5em;
  cursor: pointer;
}
</style>
